import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import NewHeroSection from "@/components/home/NewHeroSection";
import CampaignBanner from "@/components/home/CampaignBanner";
import ProductSection from "@/components/ProductSection";
import Footer from "@/components/Footer";
import { useProducts } from "@/hooks/useProducts";

const Index = () => {
  const { products, loading, error } = useProducts();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-primary mx-auto mb-4" />
            <p className="text-lg text-muted-foreground">Loading products...</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center max-w-md px-4">
            <div className="text-red-500 text-lg font-semibold mb-2">
              Error loading products
            </div>
            <p className="text-muted-foreground">{error.message}</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  // Split products into sections
  const featuredProducts = products.filter(p => p.featured).slice(0, 8);
  const newArrivals = products.slice(0, 8);
  const popularProducts = products.slice(8, 16);

  // Transform products for campaign banner
  const campaignProducts = products.slice(0, 5).map(p => ({
    id: p.id,
    name: p.name,
    price: p.price,
    image: p.images?.[0]?.url || '/placeholder.svg',
    badge: p.sale_price ? 'SALE' : undefined,
  }));

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        {/* New Professional Hero Section */}
        <NewHeroSection products={products} />

        {/* Campaign Banner - Example: Back to School */}
        <CampaignBanner
          title="Welcome Back To School"
          subtitle="Essential supplies starting at 0.150 BD"
          products={campaignProducts}
          backgroundColor="from-blue-600 via-purple-600 to-pink-600"
          campaignUrl="/shop?category=school"
        />

        {/* Original Hero with "Print Your Imagination" */}
        <Hero />

        <ProductSection
          title="New Arrivals"
          subtitle="Fresh designs just dropped"
          products={newArrivals}
        />
        <ProductSection
          title="Popular Products"
          subtitle="Customer favorites"
          products={popularProducts}
          background="accent"
        />
        {featuredProducts.length > 0 && (
          <ProductSection
            title="Featured Products"
            subtitle="Handpicked by our team"
            products={featuredProducts}
          />
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Index;
